<template>
    <div>
        <a :href="orderUrl(mainOrderId)">{{ mainOrderId }}</a>

        <template v-if="additionalOrderIdsCount > 0">
            <span v-for="(additionalOrderId, index) in additionalOrderIds" :key="index">
                <a :href="orderUrl(additionalOrderId)">{{ additionalOrderId }}</a>
                <template v-if="(index + 1) !== additionalOrderIdsCount">, </template>
            </span>
        </template>
    </div>
</template>

<script>
export default {
  props: {
    mainOrderId: {
      type: [String, Number],
      default: null,
    },
    additionalOrderIds: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    additionalOrderIdsCount() {
      return this.additionalOrderIds.length
    }
  },
  methods: {
    orderUrl(id) {
      return Routing.generate('order_update', { id: id })
    }
  },
}
</script>
